import { Box, BoxProps, Flex, Text, VisuallyHidden } from '@chakra-ui/react';
import * as React from 'react';
import { FC } from 'react';
import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';
import { Logo } from './Logo';
import { NavContent } from './navBar/NavContent';

interface NavbarProps extends BoxProps {
  homepageGutter?: boolean;
}

export const Navbar: FC<NavbarProps> = ({ homepageGutter = false, ...props }) => {
  const { t } = useTranslation('common');

  return (
    <Box _dark={{ color: 'secondary.900' }} {...props}>
      <Box
        as='header'
        height='16'
        position='relative'
        zIndex='sticky'
        width='full'
        maxW={homepageGutter ? '1384px' : '8xl'}
        mx='auto'
        px={homepageGutter ? 'var(--homepage-gutter)' : 0}
      >
        <Box
          height='100%'
          mx='auto'
          ps={homepageGutter ? 0 : { base: '6', md: '0' }}
          pe={homepageGutter ? 0 : { base: '5', md: '0' }}
        >
          <Flex as='nav' aria-label={t('nav.ariaLabel')} align='center' justify='space-between' height='100%'>
            <Box rel='home'>
              <NextLink href='/'>
                <Flex direction='column' alignItems='flex-start'>
                  <Logo height={16} />
                  <Text fontSize='xs' fontWeight='light' color='accent-alt' mt='-1' lineHeight='1' ml={5}>
                    {t('nav.poweredBy')}
                  </Text>
                </Flex>
                <VisuallyHidden>eezi</VisuallyHidden>
              </NextLink>
            </Box>
            <NavContent.Desktop display={{ base: 'none', md: 'flex' }} />
            <NavContent.Mobile display={{ base: 'flex', md: 'none' }} />
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};
